<div
  class="idp__text"
  [innerHTML]="content"
  [ngStyle]="styles"
  [ngClass]="textContainerClass"
  *ngIf="config.visible"
></div>
